var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.phones, function (phone) {
      return _c(
        "div",
        {
          key: phone.id,
          staticClass: "text-body-1 mb-3",
          class: _setup.isMobile ? "text--text" : "text-secondary--text",
          attrs: { "data-qa": "contacts-item-phone" },
        },
        [
          phone.description
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _setup.transDynamic(
                        phone,
                        `description,${_setup.language},${_setup.needTranslate}`
                      )
                    ) +
                    "\n    "
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _setup.isMobile
            ? _c(
                "a",
                {
                  staticClass: "link-decoration-none primary--text",
                  attrs: { href: `tel:${phone.phone_number_link}` },
                },
                [_vm._v("\n      " + _vm._s(phone.phone_number) + "\n    ")]
              )
            : _c("span", { staticClass: "text--text" }, [
                _vm._v("\n      " + _vm._s(phone.phone_number) + "\n    "),
              ]),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }